import backendApi from '../common/backendApi';
import { Location } from '../models/location';

export const getLocations = async (): Promise<Location[]> => {
  const response = await backendApi.request({
    method: 'get',
    url: '/api/v1/locations',
  });

  return response.data;
};
